import F1 from "../assets/s21.jpeg";
import F2 from "../assets/s22.jpeg";
import F3 from "../assets/s23.jpeg";

const Servicios2 = () => {
  const services = [
    { name: "Lavandería", text:"Lavamos tu ropa y cobertores", src: F1 },
    { name: "Teñido de ropa", text:"Dale otra oportunidad a tus prendas para usarlas más tiempo", src: F2 },
    { name: "Lavado industrial", text:"Servicios de lavandería a hoteles, restaurantes, centros deportivos, uniformes y hospitales.", src: F3 },
  ];

  return (
    <div className="p-4">
      <h3 className="text-center text-lg text-sky-400">Conózcanos</h3>
      <h2 className="text-center text-3xl font-semibold">Nuestros servicios</h2>
      <h3 className="text-center text-lg text-sky-400">
        Lavandería para la ropa de toda tu familia, semindustrial e industrial
      </h3>

      <div className="h-fit grid grid-cols-1 md:grid-cols-3 p-4 md:px-12 gap-4">
        {services.map((service, index) => (
          <div
            key={index}
            className="relative group aspect-square rounded-full overflow-hidden shadow-lg"
          >
            {/* Imagen */}
            <div
              className="absolute inset-0 bg-cover bg-center group-hover:scale-110 transition-transform duration-500"
              style={{ backgroundImage: `url(${service.src})` }}
            />

            {/* Overlay */}
            <div className="absolute inset-0 bg-black/50 group-hover:bg-black/30 transition-colors duration-500"></div>

            {/* Contenido */}
            <div className="relative z-10 flex flex-col items-center justify-center h-full w-full text-center px-4 font-bold">
              {/* Nombre */}
              <span className="text-sky-300 text-sm md:text-lg font-semibold opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                {service.name}
              </span>
              {/* Texto */}
              <p className="text-white mt-2 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                {service.text}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Servicios2;
